var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("list-subject-types", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "subjectType",
            staticClass: "w-100",
            attrs: {
              autocomplete: "",
              label: "Destinos",
              name: "subjectType",
              "data-cy": "subject-type",
              danger: _vm.errors.has("step-2-part-2.subjectType"),
              "danger-text": _vm.errors.first("step-2-part-2.subjectType")
            },
            model: {
              value: _vm.subjectForm.subjectType,
              callback: function($$v) {
                _vm.$set(_vm.subjectForm, "subjectType", $$v)
              },
              expression: "subjectForm.subjectType"
            }
          })
        ],
        1
      ),
      _vm.subjectForm.subjectType === "docDigital"
        ? _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("list-institutions-doc-digital", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.subjectForm.subjectType === "docDigital"
                    },
                    expression:
                      "{ required: subjectForm.subjectType === 'docDigital'}"
                  }
                ],
                ref: "subjectTypeDigitalDoc",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Lista de Instituciones DocDigital",
                  name: "subjectTypeDigitalDoc",
                  "parent-value": _vm.subjectForm.subject,
                  danger: _vm.errors.has("step-2-part-2.subjectTypeDigitalDoc"),
                  "danger-text": _vm.errors.first(
                    "step-2-part-2.subjectTypeDigitalDoc"
                  ),
                  "data-cy": "subjectTypeDigitalDoc"
                },
                on: { "full-input": _vm.setSubject },
                model: {
                  value: _vm.subjectForm.subjectTypeDigitalDoc,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subjectTypeDigitalDoc", $$v)
                  },
                  expression: "subjectForm.subjectTypeDigitalDoc"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          class: {
            "col-12": _vm.subjectForm.subjectType === "docDigital",
            "col-md-6": _vm.subjectForm.subjectType !== "docDigital"
          }
        },
        [
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType === "oficinas"
            ? _c("list-offices", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType === "oficinas"
                    },
                    expression:
                      "{ required:  !isInput.includes(subjectForm.subjectType)\n          && subjectForm.subjectType === 'oficinas' }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Oficina",
                  name: "subject",
                  "data-cy": "subject",
                  danger: _vm.errors.has("step-2-part-2.subject"),
                  "danger-text": _vm.errors.first("step-2-part-2.subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType === "unidades"
            ? _c("list-groups", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType === "unidades"
                    },
                    expression:
                      "{ required:  !isInput.includes(subjectForm.subjectType)\n          && subjectForm.subjectType === 'unidades' }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Unidad",
                  name: "subject",
                  "data-cy": "subject",
                  typeList: 1,
                  danger: _vm.errors.has("step-2-part-2.subject"),
                  "danger-text": _vm.errors.first("step-2-part-2.subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType !== "usuarios" &&
          _vm.subjectForm.subjectType !== "oficinas" &&
          _vm.subjectForm.subjectType !== "unidades"
            ? _c("list-subjects", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType !== "usuarios"
                    },
                    expression:
                      "{\n          required: !isInput.includes(subjectForm.subjectType)\n            && subjectForm.subjectType !== 'usuarios'\n        }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Lista de Destino",
                  name: "subject",
                  "data-cy": "subject",
                  "parent-value": _vm.subjectForm.subjectType,
                  disabled:
                    !_vm.subjectForm.subjectType ||
                    this.institutionsDocDigitalState.loading,
                  danger: _vm.errors.has("step-2-part-2.subject"),
                  "danger-text": _vm.errors.first("step-2-part-2.subject")
                },
                on: { input: _vm.clearEntities },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType === "usuarios"
            ? _c("list-user", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType === "usuarios"
                    },
                    expression:
                      "{\n          required: !isInput.includes(subjectForm.subjectType)\n            && subjectForm.subjectType === 'usuarios'\n        }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  withFilters: "",
                  rolId: "7441a75e-80b9-486a-8595-34c487a56dd9",
                  autocomplete: "",
                  label: "Lista de Destino",
                  name: "subject",
                  "data-cy": "subject",
                  disabled: !_vm.subjectForm.subjectType,
                  danger: _vm.errors.has("step-2-part-2.subject"),
                  "danger-text": _vm.errors.first("step-2-part-2.subject"),
                  "filter-me-user": _vm.filterMe
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          _vm.isInput.includes(_vm.subjectForm.subjectType)
            ? _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.isInput.includes(
                        _vm.subjectForm.subjectType
                      )
                    },
                    expression:
                      "{ required: isInput.includes(subjectForm.subjectType) }"
                  }
                ],
                key: "subject-input",
                staticClass: "w-100",
                attrs: {
                  label: "Ingrese un nombre",
                  name: "subject",
                  "data-cy": "subject",
                  danger: _vm.errors.has("step-2-part-2.subject"),
                  "danger-text": _vm.errors.first("step-2-part-2.subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm.emailRequired.includes(_vm.subjectForm.subjectType)
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.emailRequired.includes(
                        _vm.subjectForm.subjectType
                      ),
                      email: true
                    },
                    expression:
                      "{\n            required: emailRequired.includes(subjectForm.subjectType)\n            ,\n            email: true\n          }"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Correo Electrónico Persona Destinatario",
                  name: "subjectEmail",
                  "data-cy": "subjectEmail",
                  danger: _vm.errors.has("step-2-part-2.subjectEmail"),
                  "danger-text": _vm.errors.first("step-2-part-2.subjectEmail")
                },
                model: {
                  value: _vm.subjectForm.subjectEmail,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subjectEmail", $$v)
                  },
                  expression: "subjectForm.subjectEmail"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.subjectForm.subjectType === "usuarios" && !_vm.isConvention
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "vs-select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: _vm.needProvidence
                      },
                      expression: "{\n        required: needProvidence\n      }"
                    }
                  ],
                  staticClass: "w-100 con-select autocompletex",
                  attrs: {
                    autocomplete: "",
                    label: "Seleccione tipo de providencia",
                    name: "providence",
                    "data-cy": "providence",
                    "data-vv-as": "providencia",
                    danger: _vm.errors.has("step-2-part-2.providence"),
                    "danger-text": _vm.errors.first("step-2-part-2.providence")
                  },
                  model: {
                    value: _vm.subjectForm.providence,
                    callback: function($$v) {
                      _vm.$set(_vm.subjectForm, "providence", $$v)
                    },
                    expression: "subjectForm.providence"
                  }
                },
                [
                  _c("vs-select-item", {
                    attrs: {
                      value: _vm.providenceTypes.KNOWLEDGE,
                      text: "Conocimiento"
                    }
                  }),
                  _c("vs-select-item", {
                    attrs: {
                      value: _vm.providenceTypes.MANAGEMENT,
                      text: "Para gestión"
                    }
                  }),
                  _vm.forConvention
                    ? _c("vs-select-item", {
                        attrs: {
                          value: _vm.providenceTypes.PARTICIPANT,
                          text: "Visto bueno"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          !_vm.isAguasAndinas
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("label", [_vm._v("Fecha Vencimiento")]),
                  _c("b-form-datepicker", {
                    attrs: {
                      locale: "es",
                      min: _vm.minDate,
                      placeholder: "Fecha vencimiento",
                      name: "providenceExpiration",
                      "data-cy": "providenceExpiration",
                      "label-help":
                        "Puede usar las flechas del teclado y espacio"
                    },
                    model: {
                      value: _vm.subjectForm.providenceExpiration,
                      callback: function($$v) {
                        _vm.$set(_vm.subjectForm, "providenceExpiration", $$v)
                      },
                      expression: "subjectForm.providenceExpiration"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isAguasAndinas
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("label", [_vm._v("Fecha Vencimiento")]),
                  _c(
                    "b-form-datepicker",
                    _vm._b(
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: _vm.needProvidence
                            },
                            expression:
                              "{\n        required: needProvidence\n      }"
                          }
                        ],
                        attrs: {
                          "today-button": "",
                          "reset-button": "",
                          "close-button": "",
                          min: _vm.minDate,
                          max: _vm.maxDate,
                          "show-decade-nav": false,
                          "hide-header": false,
                          placeholder: "Fecha vencimiento",
                          name: "providenceExpiration",
                          "data-cy": "providenceExpiration",
                          "data-vv-as": "fecha vencimiento",
                          state: _vm.errors.has(
                            "step-2-part-2.providenceExpiration"
                          )
                            ? false
                            : null
                        },
                        model: {
                          value: _vm.subjectForm.providenceExpiration,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.subjectForm,
                              "providenceExpiration",
                              $$v
                            )
                          },
                          expression: "subjectForm.providenceExpiration"
                        }
                      },
                      "b-form-datepicker",
                      _vm.labels[_vm.locale] || {},
                      false
                    )
                  ),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.errors.first("step-2-part-2.providenceExpiration")
                        ) +
                        " "
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12 d-flex align-items-end justify-content-end" },
        [
          _vm.error.message !== ""
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n       vs-input--text-validation-span v-enter-to text-right",
                  staticStyle: { height: "32px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "col-12 d-flex align-items-end justify-content-end" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { "data-cy": "add-recipient-button", variant: "primary" },
              on: {
                click: function($event) {
                  return _vm.addSubject()
                }
              }
            },
            [_vm._v(" Agregar Destinatario ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }